<template>
  <svg
    class="svg"
    :width="width"
    :height="height"
    viewBox="0 0 13 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 0V16L12.5333 8L0 0Z" :fill="fill" />
  </svg>
</template>

<script>
export default {
  name: 'IconPlay',

  props: {
    width: {
      type: String,
      default: '13'
    },

    height: {
      type: String,
      default: '16'
    },

    fill: {
      type: String,
      default: '#9FAAB6'
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables';

.svg {
  min-width: 13px;
  min-height: 16px;
}

.svg:hover path {
  fill: $green-hover;
}
</style>
